/**
 * Converts a date from local time to UTC. This will change the actual time. ex. if the browser is in Seattle, the Date
 * returned will be 8 hours in the future.
 *
 * Why: MUI can't handle UTC, it deals with local time. Our whole app deals with UTC. We have to trick it into displaying
 * UTC with this method.
 */
export const fromLocalToUTC = (localDate) => {
    let timeZoneOffset = localDate.getTimezoneOffset(); // in minutes
    return new Date(localDate.getTime() + (timeZoneOffset * 60 * 1000));
}

/**
 * Returns a date representing the end of the day in Greenwich London (UTC) for given input date.
 */
export const endOfUTCDay = (date) => {
    let newDate = new Date(date);
    newDate.setUTCHours(23, 59, 59);
    return newDate;
}

/**
 * Returns a date representing the start of the day in Greenwich London (UTC) for given input date.
 */
export const startOfUTCDay = (date) => {
    let newDate = new Date(date);
    newDate.setUTCHours(0, 0, 0, 0);
    return newDate;
}
